/**
 * @file  feedback.ts
 * @description  plug-in for feedback features. This is enabled for each deployment
 *               To disable, do not set the REACT_APP_FEEDBACK on the enviroment file
 *               sessions are limited to 35/day
 *
 * @author ogarcia (ozkary)
 * @date 03072022
 */

/**
 * configure the site key on the env file. Make sure update the env file for the deployment step
 * Each site as a key
 */
const feedbackKey = process.env.REACT_APP_FEEDBACK;

/**
 * call to bootstrap the widget on the body of the document
 * enable the
 * @returns void
 */
const feedback = (): void => {
  if (!feedbackKey) {
    return;
  }

  // define the dynamic properties to support the widget
  interface Window {
    hj: { q: string[]};
    _hjSettings: Record<string, unknown>
  }

  const w = window as unknown as Window;
  // define the hj property and hjsettings which are expected for the widget to load
  w.hj =
    w.hj ||
    function () {
      (w.hj.q = w.hj.q || []).push(...args);
    };

  w._hjSettings = { hjid: feedbackKey, hjsv: 6 };
  /**
   * bootstrap the widget to the document. Notice the site key
   */
  const coreCall = document.createElement('script');
  coreCall.src = `https://static.hotjar.com/c/hotjar-${feedbackKey}.js?sv=6`;
  coreCall.defer = true;
  coreCall.crossOrigin = 'anonymous';
  coreCall.setAttribute('async', '1');
  document.body.appendChild(coreCall);
};

/**
 * export the boot strappping function
 * @usage feedback()
 */
export default feedback;
